<div class="wizard-layout">
    <app-header></app-header>
    @if(impersonatedUser!==''){<app-impersonation-header></app-impersonation-header>}
    <!-- Unified Wizard Container -->
    <div class="wizard-main-container container" [class.is-mobile]="isMobile">
        
        <!-- Mobile Header Navigation Toggles (Flattened for Grid Interleaving) -->
        <div class="back-link mobile-only" *ngIf="isMobile">
            <a (click)="goBack()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to home page
            </a>
        </div>

        <!-- THE ARCHITECTURAL CORE: Flat siblings for CSS Grid ordering on mobile -->
        <div class="wizard-grid-wrapper">

            <!-- Mobile Headers Loop -->
            <ng-container *ngIf="isMobile">
                <div *ngFor="let step of steps; let i = index" 
                     class="accordion-header mobile-only" 
                     [class.active]="activeStepIndex === i"
                     [class.completed]="isStepCompleted(i)"
                     [style.grid-row]="i * 2 + 1"
                     (click)="toggleStep(i)">
                    
                    <div class="step-indicator-wrapper">
                        <div class="step-indicator">
                            <span *ngIf="!isStepCompleted(i)">{{ step.stepNumber }}</span>
                            <span *ngIf="isStepCompleted(i)" class="check-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                    stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </span>
                        </div>
                        <div class="step-info">
                            <h3 class="step-title">{{ step.title }}</h3>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Main Content (Stable Outlet) -->
            <main class="wizard-content-area" [style.grid-row]="isMobile ? (activeStepIndex * 2 + 2) : 'auto'">
                <div class="wizard-content-card">
                    <router-outlet></router-outlet>
                </div>
            </main>

            <!-- Desktop Sidebar -->
            <aside class="wizard-sidebar desktop-only" *ngIf="!isMobile">
                <app-wizard-menu></app-wizard-menu>
            </aside>
        </div>
    </div>

    <app-footer-layout></app-footer-layout>
</div>
<app-loader></app-loader>